import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  useCallback
} from "react";
import styled, { css } from "styled-components";
import { Chart } from "react-charts";
import useWindowWidth from "../UI/windowEffects";
import * as _ from "lodash";
import { format, parseISO } from "date-fns";
import CustomTooltip from "./customToolTip";

const defs = (
  <defs>
    <linearGradient id="0" x1="0" x2="0" y1="1" y2="0">
      <stop offset="0%" stopColor="#003271" />
      <stop offset="100%" stopColor="#003271" />
    </linearGradient>
    <linearGradient id="1" x1="0" x2="0" y1="1" y2="0">
      <stop offset="0%" stopColor="#ef006e" />
      <stop offset="100%" stopColor="#ef006e" />
    </linearGradient>
    <linearGradient id="2" x1="0" x2="0" y1="1" y2="0">
      <stop offset="0%" stopColor="#42E695" />
      <stop offset="100%" stopColor="#3BB2B8" />
    </linearGradient>
    <linearGradient id="3" x1="0" x2="0" y1="1" y2="0">
      <stop offset="0%" stopColor="#F4Ea0A" />
      <stop offset="100%" stopColor="#df4081" />
    </linearGradient>
  </defs>
);

// style
const KeikenMonthsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  z-index: 1000;
  overflow: visible;
`;

// style
const ChartWrapper = styled.div`
  flex: 1 1 auto;
  padding: 5px;
  /* ${({ width }) =>
    width
      ? css`
          width: ${width - 30}px;
        `
      : null} */
      width: 100%;
  height: 260px;
  z-index: 100;
`;

const KeikenScore = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 1 1 auto;
  width: 80px;
  background: #003271;
  color: white;
  padding: 12px 8px 6px 8px;
  border-radius: 3px;
  margin-bottom: 10px;
  align-items: center;
  z-index: 10;

  .value {
    margin-top: 10px;
    font-weight: bold;
    font-size: 20px;
  }
  .label {
    color: white;
    position: absolute;
    top: 5px;
    font-size: 14px;
  }
`;

// ****************************************************************
//
// KeikenMonths component
//
// ****************************************************************
const KeikenMonths = ({ activities }) => {
  const windowWidth = useWindowWidth();
  const [{ activeSeriesIndex, activeDatumIndex }, setState] = useState({
    activeSeriesIndex: -1,
    activeDatumIndex: -1
  });

  const kmRef = useRef(null);

  //   useEffect(() => {

  //     // prepareData()
  //   })

  const getActivityData = activityTypeId => {
    if (!activities) {
      return false;
    }
    // console.log("getActivityData >> Activities: ", activities);

    // month year to activities
    const activitiesWithMY = activities.map(act => {
      const monthYear = format(parseISO(act.Date), "MMMyy");
      const month = format(parseISO(act.Date), "M");
      return { ...act, monthYear, month };
    });

    const activityData = _(activitiesWithMY)
      .filter(act => act.ActivityTypeId == activityTypeId)
      .groupBy("monthYear")
      .map((ac, id) => [id, ac.length, ac[0].month])
      .value();

    console.log("getActivityData >> activitiesWithMY: ", activitiesWithMY);
    console.log("getActivityData >> activityData: ", activityData);

    return activityData;
  };

  const getKeikenScore = () => {
    console.log("getActivityData >> Activities: ", activities);

    const score = _.sumBy(activities, "Score");

    console.log("getActivityData >> score: ", score);

    return score;
  };

  const data = useMemo(
    () => [
      {
        label: "Træning",
        data: getActivityData("NCDFOapeUK5GsU6PHTBo")
      },
      {
        label: "Undervisning",
        data: getActivityData("qw0N72HFzjXJeNQAmCk2") // Instruktør / undervisning
      }
    ],
    []
  );

  const axes = useMemo(
    () => [
      { primary: true, type: "ordinal", position: "bottom" },
      { type: "linear", position: "left", stacked: true }
    ],
    []
  );

  const series = useMemo(
    () => ({
      type: "bar"
    }),
    []
  );

  const getSeriesStyle = useCallback(
    series => ({
      color: `url(#${series.index % 4})`,
      opacity:
        activeSeriesIndex > -1
          ? series.index === activeSeriesIndex
            ? 1
            : 0.3
          : 1
    }),
    [activeSeriesIndex]
  );

  const getDatumStyle = React.useCallback(
    datum => ({
      r:
        activeDatumIndex === datum.index &&
        activeSeriesIndex === datum.seriesIndex
          ? 7
          : activeDatumIndex === datum.index
          ? 5
          : datum.series.index === activeSeriesIndex
          ? 3
          : datum.otherHovered
          ? 2
          : 2
    }),
    [activeDatumIndex, activeSeriesIndex]
  );

  const tooltip = React.useMemo(
    () => ({
      render: ({ datum, primaryAxis, getStyle }) => {
        return (
          <CustomTooltip
            {...{ getStyle, primaryAxis, datum }}
            activities={activities}
          />
        );
      }
    }),
    []
  );

  return (
    <KeikenMonthsWrapper>
      <ChartWrapper>
        <Chart
          data={data}
          axes={axes}
          series={series}
          getSeriesStyle={getSeriesStyle}
          getDatumStyle={getDatumStyle}
          renderSVG={() => defs}
          //   tooltip
          primaryCursor
          tooltip={tooltip}
        />
      </ChartWrapper>
      <KeikenScore>
        <div className="label">Keiken</div>
        <div className="value">{getKeikenScore()}</div>
      </KeikenScore>
    </KeikenMonthsWrapper>
  );
};

export default KeikenMonths;
